<script>
    import BaseColorInput from "./BaseColorInput";
    import withinBounds from "../../../../../Lib/helpers/withinBounds";
    import Color        from "../../../../../Lib/Color";

    export default {
        name: "HsvBase",
        extends: BaseColorInput,

        computed: {
            hsv() {
                return this.draft.hsv();
            },

            hue() {
                return Math.round(this.hsv.hue);
            },

            saturation() {
                return Math.round(this.hsv.saturation);
            },

            displayValue() {
                return Math.round(this.hsv.value);
            },
        },

        data() {
            return {
                colorType: 'hsv',
            }
        },

        methods: {
            getValue() {
                return this.hsv;
            },

            getSanitizedColor(hsv) {
                hsv = this.sanitize(hsv);
                return Color.fromHSV(hsv);
            },

            sanitize(hsv) {
                hsv.hue        = withinBounds(hsv.hue, 0, 360);
                hsv.saturation = withinBounds(hsv.saturation);
                hsv.value      = withinBounds(hsv.value);

                return hsv;
            },
        }
    }
</script>

<style scoped>

</style>